import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { injectable, inject } from 'inversify';
import Clipboard from 'clipboard';
let CopyService = class CopyService {
    constructor(i18n, dialogService) {
        this.i18n = i18n;
        this.dialogService = dialogService;
    }
    copy($event, context) {
        const clipboard = new Clipboard($event.currentTarget, {
            text: () => context,
        });
        clipboard.on('success', () => {
            this.dialogService.success(this.i18n.t('backoffice.common.copySuccess'));
            clipboard.destroy();
        });
        clipboard.on('error', (err) => {
            console.log('Action:', err);
            this.dialogService.error(this.i18n.t('backoffice.common.copyFailed'));
            clipboard.destroy();
        });
        clipboard.onClick($event, context);
    }
};
CopyService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.DialogService)),
    __metadata("design:paramtypes", [Object, Object])
], CopyService);
export { CopyService };
